import { useEffect, useState } from "react";
import { FiChevronUp } from "react-icons/fi";

const BackToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 420);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const goTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
      type="button"
      className={`back-to-top-btn ${visible ? "is-visible" : ""}`}
      onClick={goTop}
      aria-label="بازگشت به بالای صفحه"
      title="بازگشت به بالا"
    >
      <FiChevronUp size={23} />
    </button>
  );
};

export default BackToTopButton;
